import React from "react";
import { Typography } from "@/components/Typography";
import { ReactSVG } from "react-svg";

import { Icons } from "@/types/icons";
import { VcardHeaderProps } from "../types";
import { PreviewCloudinaryImage, PreviewPrimaryAction } from "@/features/previews/shared";

export const VcardHeader = ({
  data,
  translations,
  onDownloadClick,
  isInitialPreview,
}: VcardHeaderProps) => {
  const { themeColor, logoUrl, fullName, profession } = data;

  return (
    <div>
      <div
        className="vcard-template__top-section"
        style={{ background: themeColor?.backgroundColor }}
      >
        {logoUrl && (
          <div className="vcard-template__logo-container">
            <PreviewCloudinaryImage
              src={logoUrl}
              alt="vcard avatar"
              className="vcard-template__logo-background"
              placeholderClass="vcard-template__logo-background"
              variant="logo-large"
              isInitPreview={isInitialPreview}
            />
          </div>
        )}
        {fullName && (
          <div className="vcard-template__title">
            <Typography
              Tag="p"
              size="l"
              classname="u-semibold u-spacing-4"
            >
              {fullName}
            </Typography>
          </div>
        )}

        {profession && (
          <div className="vcard-template__subtitle">
            <Typography
              Tag="p"
              classname="u-spacing-5"
            >
              {profession}
            </Typography>
          </div>
        )}
      </div>
      {fullName && (
        <div className="u-line vcard-template__contact-button">
          <PreviewPrimaryAction
            dataQA="preview-vcard-add-button"
            iconLeft
            icon={
              <ReactSVG
                className="button__icon"
                src={`/svg/icons/${Icons.addContact}.svg`}
              />
            }
            spacing={2}
            text={translations?.preview_add_button_initial}
            buttonColor={themeColor?.buttonColor}
            onClick={onDownloadClick}
          />
        </div>
      )}
    </div>
  );
};
